export const EXTERNAL_REVIEW_ACTION_TYPE = {
  DELETE: "Delete",
  TERMINATE: "Terminate",
  RECALL: "Recall",
};
